interface HyperPayAmountSummaryProps {
  label: string;
  totalNumeric: number;
}

/** Amount strip above the WPWL card form inside HyperPay modals */
const HyperPayAmountSummary = ({
  label,
  totalNumeric,
}: HyperPayAmountSummaryProps) => {
  const formatted = Number.isFinite(totalNumeric)
    ? totalNumeric.toFixed(2)
    : "0.00";

  return (
    <div className="ac-hyperpay-amount-card ac--font-expo" role="status">
      <span className="ac-hyperpay-amount-card__label">{label}</span>
      <div className="ac-hyperpay-amount-card__value">
        <span className="ac-hyperpay-amount-card__figure">{formatted}</span>
        <span
          className="icon-saudi_riyal ac-hyperpay-amount-card__currency"
          aria-hidden
        />
      </div>
    </div>
  );
};

export default HyperPayAmountSummary;
